import Header from "./components/Header/Header";
import Main from "./components/Main/Main";
import About from "./components/About/About";
import Skills from "./components/Skills/Skills";
import Works from "./components/Works/Works";
import Contacts from "./components/Contacts/Contacts";

function App() {
  return (
    <div>
      <Header />
      <Main />
      <About />
      <Skills />
      <Works />
      <Contacts />
    </div>
  );
}

export default App;
